import { colorsDark } from '../../../themes/dark-colors';
import { colorsV2 } from '../../../themes/colors-v2';

export const linearProgressDarkTheme = {
  primary: {
    color: colorsDark.blue[400],
    background: colorsDark.blue[200],
  },
  radiant: {
    background: colorsDark.blue[200],
    color: colorsV2.gradient.radiant,
  },
};
